export const differenceInDays = (date1 : any, date2 : any) : any => {
    // Convertir las fechas a objetos Date si no lo son ya
    const d1 = date1;
    const d2 = date2;

    if(!d1 && !d2){
      return ""
    }
    
    // Asegurarse de que las fechas sean válidas
    if (isNaN(d1.getTime()) || isNaN(d2.getTime())) {
      //throw new Error('Una o ambas fechas son inválidas');
      return 1
    }
    
    // Calcular la diferencia en milisegundos
    const diffTime = Math.abs(d2 - d1);
    
    // Convertir la diferencia a días
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    
    return diffDays;
  }